/**
 * BigTooltip — tooltip amplio (3-4 líneas con caso de uso) + opcional link a Academy.
 * Renderiza como <span> para evitar <button>-within-<button> warnings.
 */
import { useState } from 'react';
import { APP_NAME } from '@/lib/brand';
import { HelpCircle, PlayCircle } from 'lucide-react';

export default function BigTooltip({ title, body, useCase, academySearch, side = 'right' }) {
  const [open, setOpen] = useState(false);
  return (
    <span className="relative inline-flex">
      <span
        role="button"
        tabIndex={0}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={(e) => { e.stopPropagation(); e.preventDefault(); setOpen(o => !o); }}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setOpen(o => !o); } }}
        className="text-white/40 hover:text-cyan-300 transition cursor-help"
        data-testid={`bigtip-${(title || 'help').toLowerCase().replace(/\s+/g, '-').slice(0, 30)}`}
      >
        <HelpCircle className="w-3.5 h-3.5" />
      </span>
      {open && (
        <div
          className={`absolute z-50 w-72 p-3 rounded-xl bg-slate-950 border border-cyan-400/30 shadow-xl text-[11px] text-white/85 leading-relaxed ${side === 'left' ? 'right-full mr-2' : 'left-full ml-2'} top-0`}
          role="tooltip"
        >
          <p className="text-cyan-200 font-bold text-[12px] mb-1">{title}</p>
          {body && <p className="mb-2">{body}</p>}
          {useCase && (
            <div className="mt-2 p-2 rounded bg-white/[0.04] border border-white/5">
              <p className="text-[10px] text-amber-200 uppercase tracking-wider mb-1">Ejemplo de uso</p>
              <p className="text-white/75">{useCase}</p>
            </div>
          )}
          {academySearch && (
            <a
              href={`/academy?search=${encodeURIComponent(academySearch)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-2 inline-flex items-center gap-1 text-cyan-300 hover:text-cyan-200 text-[10px]"
            >
              <PlayCircle className="w-3 h-3" /> Ver tutorial en {APP_NAME} Academy
            </a>
          )}
        </div>
      )}
    </span>
  );
}
